import magnifiAPIInstance from "./apiInstance";

export const clientAPIs = {
  getClients: () => magnifiAPIInstance.get(`/client/get`),
  addClient: ({ payload }) => magnifiAPIInstance.post(`/client/create`, payload),
  updateClient: ({ payload }) => magnifiAPIInstance.post(`/client/update`, payload),
  deleteClient: ({ payload }) => magnifiAPIInstance.delete(`/client/delete`, payload),
};
